import { createContext, useContext, useEffect, useState } from "react";
import { _auth_api } from "../DAL/Login/Login";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { visa_application } from "../components/SideBarData/SidebarData";

const AdminContext = createContext();

export const useAdminContext = () => useContext(AdminContext);

export function ContextAdmin({ children }) {
  const [userInfo, setUserInfo] = useState(null);
  const [adminSettingList, setAdminSettingList] = useState({});
  const [navItemsList, setNavItemList] = useState([]);
  const [completedSections, setCompletedSections] = useState({});
  const [savedAnswers, setSavedAnswers] = useState({});
  const [dataInFields, setDatainField] = useState({});
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [sectionList, setSectionList] = useState([]);
  const [adminSetting, setAdminSetting] = useState({});
  const [addonCaseNumber, setAddonCaseNumber] = useState(null);
  const [isOpenAuthModal, setIsOpenAuthModal] = useState(false);
  // Only Show Auth Prompt if not already authenticated in this session
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => sessionStorage.getItem("is_authenticated") === "true"
  );
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
  const [actionToRunAfterLeavingUnsavedPage, setActionToRunAfterLeavingUnsavedPage] = useState(null);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setUserInfo(JSON.parse(user));
    }
  }, [localStorage.getItem("user")]);

  useEffect(() => {
    if (!sectionList || sectionList?.length === 0) {
      setSectionList(visa_application);
    }
  }, [sectionList]);

  useEffect(() => {
    if (!selectedQuestion) {
      setSelectedQuestion(visa_application[selectedIndex]);
    }
  }, [selectedQuestion]);

  const resetContext = () => {
    setUserInfo(null);
    setAdminSettingList({});
    setNavItemList([]);
    setCompletedSections({});
    setSavedAnswers({});
    setDatainField({});
    setSelectedQuestion(null);
    setSelectedIndex(0);
    setSectionList(visa_application);
    setAdminSetting({});
    setAddonCaseNumber(null);
    setHasUnsavedChanges(false);
    setShowUnsavedDialog(false);
    setActionToRunAfterLeavingUnsavedPage(null);
  };

  const collection = {
    setUserInfo,
    userInfo,
    handleSettingList: setAdminSettingList,
    adminSettingList,
    setNavItemList,
    navItemsList,
    setCompletedSections,
    completedSections,
    savedAnswers,
    setSavedAnswers,
    dataInFields,
    setDatainField,
    selectedQuestion,
    setSelectedQuestion,
    setSelectedIndex,
    sectionList,
    setSectionList,
    adminSetting,
    setAdminSetting,
    addonCaseNumber,
    setAddonCaseNumber,
    resetContext,
    isOpenAuthModal,
    setIsOpenAuthModal,
    isAuthenticated,
    setIsAuthenticated,
    hasUnsavedChanges,
    setHasUnsavedChanges,
    showUnsavedDialog,
    setShowUnsavedDialog,
    actionToRunAfterLeavingUnsavedPage,
    setActionToRunAfterLeavingUnsavedPage,
  };

  return (
    <AdminContext.Provider value={collection}>{children}</AdminContext.Provider>
  );
}
